export default __webpack_public_path__ + "static/media/logolight.8e28a766.png";